<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div>
      <layout-panel>
        <el-upload class="upload-demo"
                   style="width:130px;margin-bottom: 10px;display: inline-block;"
                   ref="upload"
                   action=""
                   :auto-upload="false"
                   :on-change="query => onUploadFile(query, 246)"
                   accept=".xlsx,.xls"
                   :show-file-list="false">
          <el-button type="primary" size="small">批量更新城市单价
          </el-button>
        </el-upload>

        <el-button icon="sj-icon-export"
                   type="primary"
                   @click="exportCityMaps()"
                   size="small">导出省市区关系
        </el-button>

      <city-map :params=provinceParams labelName="省份" @getParams="setParams"></city-map>
      <city-map :params=cityParams labelName="市区" @getParams="setParams"></city-map>
      <city-map :params=areaParams labelName="地区" @getParams="setParams"></city-map>
      </layout-panel>
    </div>

  </div>
</template>

<script>
import CityMap from '@/views/city-map/components/CityMap'

export default {
  components: {CityMap},
  mixins: [CityMap],
  data () {
    return {
      provinceParams: {type: 0, parentid: -1},
      cityParams: {},
      areaParams: {}
    }
  },
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    setParams (params) {
      switch (params.type) {
        case 0:
          this.provinceParams = params
          break
        case 1:
          this.cityParams = params
          this.areaParams = {}
          break
        case 2:
          this.areaParams = params
          break
      }
    },
    onUploadFile (file, type) {
      let isLt10M = file.raw.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!')
        this.$refs.upload.clearFiles()
        return false
      }

      let formData = new FormData()
      formData.append('file', file.raw)
      formData.append('collection_type', 3) // 卖场管理
      formData.append('type', type) // 批量任务类型
      formData.append('file_type', 1) // 文件类型:上传excel

      request.common('createTaskBatch', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        this.onSearch()
      })
    },
    exportCityMaps () {
      request.common('batchExportCityMaps').then(res => {
        this.$confirm('任务创建成功, 是否前往批量任务列表查看?', '任务创建成功', {
          confirmButtonText: '前往任务列表',
          cancelButtonText: '关闭弹层',
          type: 'warning',
        }).then(() => {
          this.$router.push('/market/upload/table')
        }).catch(() => {})
      }).catch(() => {})
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/city-map/pages/CityMapTable.vue